import { FC, createElement, useEffect, useMemo, useState } from 'react';
import {
  DepartmentSectionsFilter,
  DepartmentSectionsFilterProps,
} from './department-sections-filter';
import { useDepartmentSections } from '../department-sections.context';
import { Option, useMediaQuery } from '@plataformaxvia/design-system';
import { useDepartmentSectionCitiesQuery } from '../../../hooks/department-section-cities-query';
import { DepartmentSectionCitiesParams } from '../../../apis/department';

const CITIES_STATUS_ACTIVE: DepartmentSectionCitiesParams['status'] = 'active';

export const DepartmentSectionsFilterContainer: FC = () => {
  const { city, setCity, expressoOnly, onExpressoOnlyChange } =
    useDepartmentSections();

  const [isOpenCity, setIsOpenCity] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [searchQueryCity, setSearchQueryCity] = useState('');

  const { data: cities } = useDepartmentSectionCitiesQuery({
    status: CITIES_STATUS_ACTIVE,
  });

  const citySections = useMemo<Option[]>(
    () => (cities ?? []).map((c) => ({ label: c, value: c })),
    [cities]
  );

  useEffect(() => {
    if (city && !citySections.some((c) => c.value === city)) {
      setCity(null);
    }
  }, [citySections, city, setCity]);

  const cityOption: Option | null = city ? { label: city, value: city } : null;

  const handleSetCity = (option: Option | null) => {
    setCity(option?.value ?? null);
  };

  const props: DepartmentSectionsFilterProps = {
    isMobile,
    isFilterOpen,
    setIsFilterOpen,
    city: cityOption,
    setCity: handleSetCity,
    citySections,
    isOpenCity,
    setIsOpenCity,
    searchQueryCity,
    setSearchQueryCity,
    expressoOnly,
    onExpressoOnlyChange,
  };

  return createElement(DepartmentSectionsFilter, props);
};
